import React from "react";
import { Col, Container, Form, Nav, Row, Button } from "react-bootstrap";

export const FormLabel = (field) => {
  const {width, height, field: bb, renderItem, rowIdentity, editTableProps, watch} = field;
  const hide = bb.hideIf ? bb.hideIf({editTableProps, rowIdentity, watch}) : false;
  return hide ? null : (
    <Form.Label style={field.style}>{bb.label}</Form.Label>
  )
}